import { DetailsFormFieldProps, DisplayProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import TextDisplay from "../formDisplays/textDisplay";
import TextInput from "../formFields/textInput";
import DetailsFormBaseField from "./detailsFormBaseField";

const TextField = (props: TextInputProps & DisplayProps & DetailsFormFieldProps) => {
  return <DetailsFormBaseField<TextInputProps> Display={TextDisplay} Input={TextInput} {...props} />;
};

export default TextField;
